import { DropdownSelect } from "@vds/selects";
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const CustomDropdown = styled.div`
  & div {
    margin-left: 0;
    width: 100%;
    min-width: inherit;
    max-width: inherit;
    & div {
      width: 100%;
      & label {
        & p {
          font-family: "neue-haas-grotesk-text";
          font-style: normal;
          font-weight: 700;
          font-size: ${(props) => (props?.userLanguage === "fr-FR" && props?.windowSize.width < 400 && props?.isUserVerification ? "11px" : "12px")};
          line-height: 12px;
          margin-bottom: 8px;
          margin-top: 24px;
          color: ${(props) => (props.disabled ? "#000000" : "")};
          display: ${(props) => (props.required ? "grid" : "")};
          grid-template-columns: ${(props) => (props.required ? "1fr 10px" : "")};

          @media (max-width: 679px) {
            margin-top: 16px;
          }
          & span {
            width: 80%;
            display: ${(props) => (props.required ? `block` : "none")};
            &::after {
              color: #747676;
              content: ${(props) => (props.translationContent ? `${props.translationContent}` : "")};
            }
          }
        }
      }
    }
    & span {
      & span {
        & div {
          height: 2.75rem;
          background: #ffffff;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          width: 100%;
          background: ${(props) => (props.disabled ? "#f2f2f2" : "")};
          &:hover {
            border: ${(props) => (props.disabled ? "" : "1px solid black !important")};
            border-radius: ${(props) => (props.disabled ? "" : "4px")};
          }
          & span {
            top: 0.8rem;
            & div {
              border: none;
              height: auto;
              margin-top: 8px;
            }
            & svg {
              min-width: 0.75rem;
              max-width: 0.75rem;
            }
          }
        }
      }
    }
    & select {
      font-family: "neue-haas-grotesk-text";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      padding: 12px 0 12px 16px;
      color: black;
      margin: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      letter-spacing: 0;
      padding-right: 1.4rem;
      &:disabled {
        color: black;
        -webkit-text-fill-color: #000000;
        background-color: #f6f6f6;
      }
    }
  }
`;
const Required = styled.span`
  color: #0077b4 !important;
  font-size: 14px !important;
  margin: ${(props) => (props.margin ? props.margin : "")};
`;
const RedesignedDropdown = (props) => {
  return (
    <CustomDropdown
      disabled={props?.disabled}
      required={props?.isRequired}
      userLanguage={props?.userLanguage}
      windowSize={props?.windowSize}
      isUserVerification={props?.isUserVerification}
    >
      <DropdownSelect
        id={props?.id}
        label={
          <>
            {props?.label}
            {props?.isRequired && <Required margin="0 0 0 5px">*</Required>}
          </>
        }
        aria-label={props.ariaLabel}
        required={props?.isRequired}
        error={props.error ? props?.error : false}
        errorText={props.errorText ? props.errorText : ""}
        onChange={(e) => props.handleOnSelect(e.target.value)}
        value={props?.value}
        disabled={props?.disabled}
        helperText={props?.helperText}
      >
        {props.firstOption && (
          <option value="" disabled={true} style={{ backgroundColor: "lightgrey" }}>
            {props.firstOption}
          </option>
        )}
        {props.optionList.map((val) => (
          <option key={val} value={val}>
            {props?.t ? props.t(`${val}`) : val}
          </option>
        ))}
      </DropdownSelect>
    </CustomDropdown>
  );
};

RedesignedDropdown.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  handleOnSelect: PropTypes.func.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  firstOption: PropTypes.string,
  optionList: PropTypes.arrayOf(PropTypes.string).isRequired,
  t: PropTypes.func,
  userLanguage: PropTypes.string,
  windowSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  isUserVerification: PropTypes.bool,
};

export default RedesignedDropdown;
